module.exports = __webpack_public_path__ + "assets/img/pop-6.d9d5d67a.jpg";